module.exports = __webpack_public_path__ + "static/img/img2.5dd4d9dc.png";